import { Component, OnInit } from '@angular/core';
import { ArticleManageService } from '../../../../../../services/article-manage.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { UserService } from '../../../../../../services/user.service';

@Component({
    selector: 'app-article-manager-tags',
    templateUrl: './article-manager-tags.component.html',
    styleUrls: ['./article-manager-tags.component.scss'],
    standalone: false
})
export class ArticleManagerTagsComponent implements OnInit {
  loading = false;
  tags: any[] = [];
  userInfo: any;

  // Search
  searchName = '';

  // Form related
  modalVisible = false;
  modalTitle = '新增标签';
  editId: number | null = null;
  form = {
    name: '',
    // type: 'theme',
    seq: 1,
    school_id: null,
    pid: 0
  };

  constructor(
    private articleSvc: ArticleManageService,
    private message: NzMessageService,
    private modal: NzModalService,
    private userSvc: UserService
  ) {
    this.userInfo = this.userSvc.getUserInfo();
  }

  ngOnInit(): void {
    this.loadTags();
  }

  loadTags(): void {
    this.loading = true;
    const params = {
      name: this.searchName,
      school_id: this.userInfo?.school_id || null
    };
    this.articleSvc.getTags(params).then(res => {
      this.loading = false;
      this.tags = this.extractListData(res);
    }).catch(() => {
      this.loading = false;
      this.message.error('加载标签失败');
    });
  }

  private extractListData(res: any): any[] {
    if (!res) return [];
    if (Array.isArray(res)) return res;
    if (Array.isArray(res.data)) return res.data;
    if (Array.isArray(res.rows)) return res.rows;
    if (Array.isArray(res.list)) return res.list;
    if (res.data) {
      if (Array.isArray(res.data.list)) return res.data.list;
      if (Array.isArray(res.data.rows)) return res.data.rows;
    }
    return [];
  }

  openAdd(): void {
    this.modalTitle = '新增标签';
    this.editId = null;
    this.form = {
      name: '',
      // type: 'theme',
      seq: 1,
      school_id: this.userInfo?.school_id || 0,
      pid: 0
    };
    this.modalVisible = true;
  }

  openEdit(item: any): void {
    this.modalTitle = '编辑标签';
    this.editId = item.id;
    this.form = {
      name: item.name,
      // type: item.type || 'theme',
      seq: item.seq || 1,
      school_id: item.school_id || this.userInfo?.school_id || 0,
      pid: item.pid || 0
    };
    this.modalVisible = true;
  }

  handleCancel(): void {
    this.modalVisible = false;
  }

  handleOk(): void {
    if (!this.form.name) {
      this.message.warning('请输入标签名称');
      return;
    }

    const data = this.editId ? { ...this.form, id: this.editId } : this.form;

    this.articleSvc.saveTag(data).then(res => {
      this.message.success(this.editId ? '更新成功' : '创建成功');
      this.modalVisible = false;
      this.loadTags();
    }).catch((err) => {
      this.message.error(err.message || '操作异常');
    });
  }

  deleteTag(id: number): void {
    this.modal.confirm({
      nzTitle: '确认删除该标签吗？',
      nzContent: '删除后无法恢复。',
      nzOkText: '确认',
      nzOkDanger: true,
      nzOnOk: () => {
        this.articleSvc.deleteTag(id).then(() => {
          this.message.success('删除成功');
          this.loadTags();
        }).catch(err => {
          this.message.error(err.message || '删除失败');
        });
      }
    });
  }
}
